import React from "react";
import { OrganizationJoinScreen } from "./OrganizationJoinScreen";
import "./admin/adminDesktop.css";

/**
 * First-run gate for authenticated users without org membership.
 * Self-service org creation is deferred; join-by-invite or join code is required.
 */
export function OrgSetupScreen({ userEmail, onComplete, onSignOut }) {
  return (
    <div className="app nx-app">
      <div
        className="adm-orgsetup"
        style={{
          maxWidth: "560px",
          margin: "0 auto",
          padding: "24px 16px 0",
          color: "#e8ecf4",
        }}
      >
        <h1 className="adm-orgsetup__title" style={{ fontSize: "22px", marginBottom: "8px" }}>
          Join your organization
        </h1>
        <p style={{ opacity: 0.85, lineHeight: 1.5, marginBottom: "8px" }}>
          {userEmail ? (
            <>
              Signed in as <strong>{userEmail}</strong>.
            </>
          ) : (
            <>You are signed in.</>
          )}{" "}
          Accept an invitation from your administrator or enter your
          organization join code to continue.
        </p>
        <p style={{ opacity: 0.65, fontSize: "14px", marginBottom: "16px" }}>
          New organizations are provisioned by Nexora Systems during early
          access. Contact your account representative if you need a join code.
        </p>
        {onSignOut && (
          <button
            type="button"
            className="nx-btn nx-btn-ghost"
            style={{ marginBottom: "8px" }}
            onClick={onSignOut}
          >
            Sign out
          </button>
        )}
      </div>
      <OrganizationJoinScreen onComplete={onComplete} />
    </div>
  );
}
